import { getCreatorSubdomainFromUrlHost } from "repoV2/utils/urls&routing/domain";

export const getLeadsFormFileUploadSubfolder = () => {
    const creatorSubdomain = getCreatorSubdomainFromUrlHost();
    return `question-leads${creatorSubdomain ? `/${creatorSubdomain}` : ""}`;
};
